import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "84",
  height: "84",
  viewBox: "0 0 84 84",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      opacity: "0.5",
      d: "M84 42C84 65.1966 65.1966 84 42 84C18.8034 84 0 65.1966 0 42C0 18.8034 18.8034 0 42 0C65.1966 0 84 18.8034 84 42Z",
      fill: "#22B44B"
    }, null, -1),
    _createElementVNode("path", {
      d: "M58.9261 30.2728C59.516 30.8634 59.8473 31.664 59.8473 32.4988C59.8473 33.3335 59.516 34.1342 58.9261 34.7248L37.9261 55.7248C37.3355 56.3147 36.5349 56.646 35.7001 56.646C34.8654 56.646 34.0647 56.3147 33.4741 55.7248L25.0741 47.3248C24.7646 47.0364 24.5164 46.6886 24.3442 46.3022C24.1721 45.9159 24.0795 45.4987 24.072 45.0758C24.0646 44.6528 24.1424 44.2327 24.3008 43.8405C24.4592 43.4482 24.695 43.0919 24.9941 42.7928C25.2933 42.4937 25.6496 42.2579 26.0418 42.0995C26.434 41.941 26.8541 41.8632 27.2771 41.8707C27.7001 41.8782 28.1172 41.9707 28.5036 42.1429C28.89 42.3151 29.2377 42.5633 29.5261 42.8728L35.7001 49.0468L45.0871 39.6556L54.4741 30.2728C55.0647 29.6829 55.8654 29.3516 56.7001 29.3516C57.5349 29.3516 58.3355 29.6829 58.9261 30.2728Z",
      fill: "#22B44B"
    }, null, -1)
  ])))
}
export default { render: render }